import i18n from "i18next";
import type { FC } from "react";
import { useTranslation } from "react-i18next";

import { PageLayout } from "../../../components/AppLayout/components/Content/components";
import { PrimaryButton } from "../../../components/Buttons/components/ActionButton";
import { useLogoutMutation } from "../../../core/router/auth/serverApi";
import { routes } from "../../../core/router/config/routes";
import { PagesStyled } from "../pagesStyled";

export type UnauthorisedPageProps = Readonly<{}>;

export const UnauthorisedPage: FC<UnauthorisedPageProps> = () => {
    const { t } = useTranslation();
    const [logout] = useLogoutMutation();
    const handleBackToLogin = async () => {
        await logout({});
        window.location.href = routes.login.path;
    };

    return (
        <PageLayout>
            <PagesStyled>
                <p className="aevi-section-subtitle">{i18n.t("common.unauthorised")}</p>
                <PrimaryButton onClick={handleBackToLogin} data-name="login_button">
                    {t("common.backToLogin")}
                </PrimaryButton>
            </PagesStyled>
        </PageLayout>
    );
};
